import React from "react";

const ICopyV2 = ({
  color = "#252526",
  width = "13",
  height = "13",
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 13 13"
      fill="none"
      {...props}
    >
      <path
        d="M9.66667 12.1667C9.66667 12.6269 9.29357 13 8.83333 13H0.833333C0.373097 13 6.711e-09 12.6269 0 12.1667V4.16667C1.28852e-07 3.70643 0.373096 3.33333 0.833333 3.33333H6.5C6.77614 3.33333 7 3.55719 7 3.83333C7 4.10948 6.77614 4.33333 6.5 4.33333H1V12H8.66667V6.5C8.66667 6.22386 8.89052 6 9.16667 6C9.44281 6 9.66667 6.22386 9.66667 6.5V12.1667Z"
        fill={color}
      />
      <path
        d="M13 4.5V0.5C13 0.223858 12.7761 0 12.5 0H8.5C8.22386 0 8 0.223858 8 0.5C8 0.776142 8.22386 1 8.5 1H12V4.5C12 4.77614 12.2239 5 12.5 5C12.7761 5 13 4.77614 13 4.5Z"
        fill={color}
      />
      <path
        d="M12.1465 0.146484C12.3417 -0.0487777 12.6583 -0.0487777 12.8535 0.146484C13.0488 0.341747 13.0488 0.658254 12.8535 0.853516L6.85352 6.85352C6.65825 7.04878 6.34175 7.04878 6.14648 6.85352C5.95122 6.65825 5.95122 6.34175 6.14648 6.14648L12.1465 0.146484Z"
        fill={color}
      />
    </svg>
  );
};

export default ICopyV2;
